module.exports = ".card {\r\n    margin-bottom: 20px;\r\n}\r\n.icon {\r\n    margin-right: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboarditem/dashboarditem.component.css
// module id = ./src/app/dashboard/dashboarditem/dashboarditem.component.css
// module chunks = main